import { forwardRef } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { InputBaseComponentProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import {
  MobileTimePicker,
  MobileTimePickerProps,
} from '@mui/x-date-pickers/MobileTimePicker';

const NumberFormatInterval = forwardRef<
  PatternFormatProps,
  Omit<InputBaseComponentProps, 'defaultValue'>
>((props, ref) => {
  return <PatternFormat {...props} getInputRef={ref} mask="_" format="##:##" />;
});
NumberFormatInterval.displayName = 'NumberFormatInterval';

export function TimePicker<TInput>({
  testid,
  ...rest
}: Omit<MobileTimePickerProps<TInput, Date>, 'renderInput'> & {
  testid: string;
}) {
  return (
    <MobileTimePicker
      {...rest}
      disableMaskedInput
      renderInput={({ inputProps, ...inputParams }) => (
        <TextField
          {...inputParams}
          variant="standard"
          InputProps={{
            inputProps: {
              ...inputProps,
              sx: {
                width: '56px',
                textAlign: 'center',
              },
              'data-testid': testid,
            },
            inputComponent: NumberFormatInterval,
          }}
        />
      )}
    />
  );
}
